<script lang="ts">
  import type { Snippet } from "svelte";
  import IconExpandMore from "virtual:icons/material-symbols/expand-more-rounded";

  interface Props {
    value: string | number;
    children?: Snippet;
    required?: boolean;
    disabled?: boolean;
    label?: string;
    onchange?: (value: any) => void;
    grow?: boolean;
  }
  let {
    disabled,
    children,
    required,
    value = $bindable(),
    onchange,
    label,
    grow,
  }: Props = $props();
</script>

<div class:has-label={!!label} class:grow class="select-wrapper">
  <div class="icon">
    <IconExpandMore />
  </div>
  <select {disabled} {required} bind:value onchange={() => onchange?.(value)}>
    {@render children?.()}
  </select>
  {#if label}
    <span>{label}</span>
  {/if}
</div>

<style lang="scss">
  @use "@astlai/common/styles/mixins" as lib;

  .select-wrapper {
    position: relative;
    border-radius: 0.5rem;
    min-width: 0px;
    // @include lib.glass-surface;
    background: var(--input-background);
    @include lib.flex-row();
    @include lib.flex-align();
    gap: 1rem;

    &:hover {
      background: var(--input-background-hover);
    }

    &.grow {
      flex: 1 1 auto;
    }

    &:not(.has-label) {
      background: transparent;
      color: var(--text-secondary);

      &:hover {
        background: var(--input-background-hover);
      }
      select {
        color: var(--text-secondary);
        padding: 0.25rem 1.75rem 0.25rem 0.5rem;
      }
      .icon {
        right: 0.25rem;
      }
    }

    .icon {
      font-size: 1rem;
      right: 0.75rem;
      height: 100%;
      position: absolute;
      @include lib.flex-row();
      @include lib.flex-align(center, center);
    }
    select {
      position: relative;
      z-index: 1;
      flex: 1 1 auto;
      padding-right: 2rem;
      cursor: pointer;
      background: transparent;
      -moz-appearance: none; /* Firefox */
      -webkit-appearance: none; /* Safari and Chrome */
      appearance: none;
      min-width: 0px;
      field-sizing: content;

      @include lib.ellipsis();

      color: var(--text-primary);
      &:focus {
        outline: transparent;
      }
    }
  }
</style>
